import { Injectable, Inject } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { LiftParameterSettingsDetail } from '../models/list-parameter-settings-detail';
import { LiftParameterSettingsList } from '../models/lift-parameter-settings-list.model';
import { LiftParameterSettingsUpdate } from '../models/lift-parameter-settings-update.model';
import { LiftParameterSettingsCreate } from '../models/list-parameter-settings-create.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LiftParameterSettingsService extends EntityService<LiftParameterSettingsDetail, LiftParameterSettingsList, LiftParameterSettingsUpdate, LiftParameterSettingsCreate> {
  constructor(
    httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    super(httpClient, baseUrl + 'api/liftParameter');
  }

  delete(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.delete(url);
  }
}
